module.exports = __webpack_public_path__ + "img/1970East-072_WEB-min.a259fa64.jpg";